import type { IntlShape } from 'react-intl'
import { getMaxGuestCount } from 'lib/offer/occupancyUtils'

export function getVillaCapacityText(intl: IntlShape, offer: App.VillaOffer | App.VillaOfferSummary) {
  if (!offer.lowestPricePackage) return ''

  const roomRate = offer.lowestPricePackage.roomRate
  if (!roomRate) {
    return ''
  }

  const roomType = offer.lowestPricePackage.roomType
  if (!roomType) {
    return ''
  }

  const capacity = getMaxGuestCount(roomRate.capacities)
  if (!capacity) return ''

  const hasBedrooms = !!roomType.numberOfBedrooms
  const hasBathrooms = !!roomType.numberOfBathrooms

  if (hasBedrooms && hasBathrooms) {
    // eslint-disable-next-line formatjs/no-multiple-plurals
    return intl.formatMessage(
      {
        id: 'EUp8iR3Cwc',
        defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}} · {bedroomCount, plural, one {# bedroom} other {# bedrooms}} · {bathroomCount, plural, one {# bathroom} other {# bathrooms}}',
        description: 'Villa capacity summary with guests, bedrooms, and bathrooms',
      },
      { guestCount: capacity, bedroomCount: roomType.numberOfBedrooms, bathroomCount: roomType.numberOfBathrooms },
    )
  }

  if (hasBedrooms) {
    // eslint-disable-next-line formatjs/no-multiple-plurals
    return intl.formatMessage(
      {
        id: 'XBB4sG7jW9',
        defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}} · {bedroomCount, plural, one {# bedroom} other {# bedrooms}}',
        description: 'Villa capacity summary with guests and bedrooms',
      },
      { guestCount: capacity, bedroomCount: roomType.numberOfBedrooms },
    )
  }

  if (hasBathrooms) {
    // eslint-disable-next-line formatjs/no-multiple-plurals
    return intl.formatMessage(
      {
        id: 'fAX5v4gCY6',
        defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}} · {bathroomCount, plural, one {# bathroom} other {# bathrooms}}',
        description: 'Villa capacity summary with guests and bathrooms',
      },
      { guestCount: capacity, bathroomCount: roomType.numberOfBathrooms },
    )
  }

  return intl.formatMessage(
    {
      id: 'pp2CPnD43C',
      defaultMessage: 'Up to {guestCount, plural, one {# guest} other {# guests}}',
      description: 'Villa capacity summary with guests only',
    },
    { guestCount: capacity },
  )
}
